export const videoReactions = {
    LIKE : "like",
    DISLIKE : "dislike"
}